/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision wheel with your options`)
};

const es_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rueda de decisiones con tus opciones`)
};

const de_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entscheidungsrad mit deinen Optionen`)
};

const nl_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beslisrad met jouw opties`)
};

const fr_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roue de décision avec vos options`)
};

const it_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruota della decisione con le tue opzioni`)
};

const pt_br2_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roleta de decisão com suas opções`)
};

const pt_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roda de decisão com as suas opções`)
};

const ja_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択肢が入った決定ホイール`)
};

const zh_dw_wheel_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含你的选项的决策转盘`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_wheel_alt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_wheel_alt(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_wheel_alt", locale)
	if (locale === "en") return en_dw_wheel_alt(inputs)
	if (locale === "es") return es_dw_wheel_alt(inputs)
	if (locale === "de") return de_dw_wheel_alt(inputs)
	if (locale === "nl") return nl_dw_wheel_alt(inputs)
	if (locale === "fr") return fr_dw_wheel_alt(inputs)
	if (locale === "it") return it_dw_wheel_alt(inputs)
	if (locale === "pt-BR") return pt_br2_dw_wheel_alt(inputs)
	if (locale === "pt") return pt_dw_wheel_alt(inputs)
	if (locale === "ja") return ja_dw_wheel_alt(inputs)
	return zh_dw_wheel_alt(inputs)
};